module.exports = __webpack_public_path__ + "img/letsbook-icon.1aa7b43c.svg";